import React from 'react';
import Styles from './styles';

export default ({ heading = null, rows = [], children = null }) => (
  <Styles>
    {heading && <header>{heading}</header>}
    {rows && !!rows.length && (
      <ul className='rows'>
        {rows.map(({ label, value, note }) => (
          <li key={label}>
            <h4 className='type-h4'>{label}</h4>
            <h5 className='type-h2'>
              {value}
              {note && <span className='type-caption'>{note}</span>}
            </h5>
          </li>
        ))}
      </ul>
    )}
    {children && <section className='content'>{children}</section>}
  </Styles>
);
